import Store from '@/store'

export function loadCrmLibs () {
  return new Promise((resolve, reject) => {
    loadJQuery()
      .then(result => Promise.all([
        loadTracking(),
        loadTrackCookies(),
        loadCreateObject()
      ]))
      .then(([result1, result2, result3]) => {
        resolve('All needed CRM libs loaded')
      })
      .catch(function (error) {
        console.error('The Error loading jQuery', error)
        reject(error)
      })
  })
}

function loadJQuery () {
  return new Promise((resolve, reject) => {
    if (!window.jQuery) {
      Store.getters.loadScript({
        url: 'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.7.1/jquery.min.js',
        callback: () => resolve('jQuery successfully loaded'),
        errorCallback: () => reject('Error loading jQuery')
      })
    } else {
      resolve('jQuery exist')
    }
  })
}

/**
 * Loads the vendor initialize jQuery (require jQuery lib).
 * This lib has similar cookie methods as 'track-cookies.js'
 * @param {*} callback
 */
function loadTracking () {
  const id = 'bpmTracking'
  const isLibExist = document.getElementById(id)

  return new Promise((resolve, reject) => {
    if (!isLibExist) {
      (function (d, s, i, r) {
        if (d.getElementById(i)) { return }
        let n = d.createElement(s)
        let e = d.getElementsByTagName(s)[0]
        n.id = i
        n.src = 'https://webtracking-v01.bpmonline.com/Src/tracking_' + r + '.js'
        n.onload = () => resolve('bpmonline tracking loaded')
        e.parentNode.insertBefore(n, e)
      })(document, 'script', 'bpmTracking', 'Clwzhbt3hrIye65KjEmdbpSY0B2OK4PVaotu5yIF')
    } else {
      resolve('tracking exist')
    }
  })
}

function loadTrackCookies () {
  const id = 'bpmonline-track-cookies'
  const isLibExist = document.getElementById(id)

  return new Promise((resolve, reject) => {
    if (!isLibExist) {
      Store.getters.loadScript({
        url: 'https://webtracking-v01.bpmonline.com/JS/track-cookies.js',
        callback: () => resolve('track-cookies.js successfully loaded'),
        errorCallback: () => reject('Error loading track-cookies.js'),
        id
      })
    } else {
      resolve('track-cookies.js exist')
    }
  })
}

/**
 * The 'create-object.js' includes the 'landing' object and its 'createObjectFromLanding' method
 */
function loadCreateObject () {
  const id = 'bpmonline-create-cookies'
  const isLibExist = document.getElementById(id)

  return new Promise((resolve, reject) => {
    if (!isLibExist) {
      Store.getters.loadScript({
        url: 'https://webtracking-v01.bpmonline.com/JS/create-object.js',
        callback: () => resolve('create-object.js successfully loaded'),
        errorCallback: () => reject('Error loading create-object.js'),
        id
      })
    } else {
      resolve('create-object.js exist')
    }
  })
}



// WEBPACK FOOTER //
// ./src/components/profile-page/impl/delete-account/imlp/modal/logic/crm/loadCrmLibsPromise.js